/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const APIMessageTypeSchema = z.enum(['success', 'error', 'warning', 'info']);

export const APIMessageSchema = z.object({
  type: APIMessageTypeSchema,
  msg: z.string(),
  code: z.string().optional(),
});

export type IAPIMessageType = z.infer<typeof APIMessageTypeSchema>;
export type IAPIMessage = z.infer<typeof APIMessageSchema>;
